// ================= IMPORT PROJECT IMAGES =================
import barbin from "../img/projects/barbinShow.png";
import biteamrit from "../img/projects/biteamrit.png";
import project5 from "../img/projects/coffeeTime.png";
import project4 from "../img/projects/cv.png";
import project3 from "../img/projects/manisocail.png";
import project6 from "../img/projects/mybook.png";
import homelogo from "../img/projects/pippyshareShow.png";
import seo from "../img/projects/seo.png";
import project7 from "../img/projects/smartshop.png";

// ================= PROJECT DATA =================
const projectsData = [
  {
    title: "Biteamrit – Fresh Cut Fruits & Organic Products",
    category: "Food & Grocery E-Commerce Website",
    description:
      "A modern platform delivering freshly cut fruits and organic products with a clean, SEO-friendly UI.",
    image: biteamrit,
    link: "https://biteamrit.in/",
  },
  {
    title: "SEO Audit Lite – Free Website SEO Analysis Tool",
    category: "SEO & Website Optimization Tool",
    description:
      "A powerful free SEO audit tool that analyzes website performance, accessibility, best practices, and SEO health with instant, actionable insights — no signup required.",
    image: seo, // showcase banner image for SEO Audit Lite
    link: "https://seo.oglitz.com/",
  },

  {
    title: "ManiSocial – Social Media Platform",
    category: "Social Media Web Application",
    description:
      "A modern social media platform supporting posts, stories, messaging, and real-time engagement.",
    image: project3,
    link: "https://manisocial.netlify.app/",
  },

  {
    title: "MBC Coffee Time – Café Website",
    category: "Restaurant / Café Website",
    description:
      "A modern café website showcasing menu, brand identity, and responsive design.",
    image: project5,
    link: "https://mbcoffeetime.netlify.app/",
  },
  {
    title: "Resume Builder",
    category: "Productivity Web Application",
    description:
      "A drag-and-drop resume builder with multiple templates and instant preview.",
    image: project4,
    link: "https://mycvmaker.netlify.app/",
  },
  {
    title: "Barbin – Search Engine",
    category: "Search Engine Web App",
    description:
      "A fast and secure search engine prototype focused on speed, accuracy, and performance.",
    image: barbin,
    link: "https://barbin.netlify.app/",
  },
  {
    title: "Online Book Store",
    category: "E-Commerce Web Application",
    description:
      "An online bookstore with product listings, cart, and checkout flow.",
    image: project6,
    link: "https://onelinebook.netlify.app/",
  },
  {
    title: "MB Shop – E-Commerce Website",
    category: "E-Commerce Web Application",
    description:
      "A scalable e-commerce website demo built with modern UI and clean UX.",
    image: project7,
    link: "https://mbshop.netlify.app/",
  },

  {
    title: "PippyShare – Visual Discovery Platform",
    category: "Pinterest-Style Web Application",
    description:
      "A Pinterest-inspired visual discovery platform designed for sharing, exploring, and organizing creative content with a clean, engaging UI.",
    image: homelogo,
    link: "https://pippyshare.netlify.app/",
  },
];

export default projectsData;
